import * as React from 'react';
import { SVGProps } from 'react';

const ArrowRightIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 24"
    fill="none"
    {...props}
  >
    <path
      fill="#212121"
      d="m14.18 17.651-1.055-1.084 3.82-3.82H4.833v-1.5h12.112l-3.82-3.819 1.054-1.084 5.654 5.654-5.654 5.653Z"
    />
  </svg>
);

export default ArrowRightIcon;
